export const generateId = function() {
  return Math.floor(Math.random() * 10000);
};



export const valueEquals = (a, b) => {
  // see: https://stackoverflow.com/questions/3115982/how-to-check-if-two-arrays-are-equal-with-javascript
  if (a === b) return true;
  if (!(a instanceof Array)) return false;
  if (!(b instanceof Array)) return false;
  if (a.length !== b.length) return false;
  for (let i = 0; i !== a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
};

export function objectAssign (target) {
    for (let i = 1, j = arguments.length; i < j; i++) {
        let source = arguments[i] || {};
        for (let prop in source) {
            if (source.hasOwnProperty(prop)) {
                let value = source[prop];
                if (value !== undefined) {
                    target[prop] = value;
                }
            }
        }
    }

    return target;
};

export function noop() {};

export function getPropByPath(obj, path, strict) {
    let tempObj = obj;
    path = path.replace(/\[(\w+)\]/g, '.$1');
    path = path.replace(/^\./, '');

    let keyArr = path.split('.');
    let i = 0;
    for (let len = keyArr.length; i < len - 1; ++i) {
        if (!tempObj && !strict) break;
        let key = keyArr[i];
        if (key in tempObj) {
            tempObj = tempObj[key];
        } else {
            if (strict) {
                throw new Error('please transfer a valid prop path to form item!');
            }
            break;
        }
    }
    return {
        o: tempObj,
        k: keyArr[i],
        v: tempObj ? tempObj[keyArr[i]] : null
    };
};

export const getValueByPath = function(object, prop) {
    prop = prop || '';
    const paths = prop.split('.');
    let current = object;
    let result = null;
    for (let i = 0, j = paths.length; i < j; i++) {
        const path = paths[i];
        if (!current) break;

        if (i === j - 1) {
            result = current[path];
            break;
        }
        current = current[path];
    }
    return result;
};


/**
 * 获取给定元素的 CSS 计算属性
 * @function
 * @ignore
 * @argument {Eement} element 给定的元素
 * @argument {String} property 属性
 */
export function getStyleComputedProperty(element, property) {
    // 注：这里会访问 DOM
    var css = window.getComputedStyle(element, null);
    return css[property];
}

/**
 * 返回给定元素用来计算滚动的父元素
 * @function
 * @ignore
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
export function getScrollParent(element) {
    var parent = element.parentNode;

    if (!parent) {  // 没有父级
        return element;
    }

    if (parent === window.document) {
        // Firefox 会将 scrollTop的判断放置的 `documentElement` 而非 `body` 上
        // 我们将判断二者谁大于0来返回正确的元素
        if (window.document.body.scrollTop) {
            return window.document.body;
        } else {
            return window.document.documentElement;
        }

    }

    // Firefox 要求我们也要检查 `-x` 以及 `-y`
    if (
        ['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow')) !== -1 ||
        ['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow-x')) !== -1 ||
        ['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow-y')) !== -1
    ) {
        // 如果检测到的 scrollParent 是 body，我们将对其父元素做一次额外的检测
        // 这样在 Chrome 系的浏览器中会得到 body，其他情况下会得到 documentElement
        // 修复 issue #65
        return parent;
    }
    return getScrollParent(element.parentNode);
}




// WEBPACK FOOTER //
// ./src/utils/util.js